module.exports = __webpack_public_path__ + "public/img/xunfeiEle.ed614e6e.png";